module.exports = __webpack_public_path__ + "static/iemas-357886c64b6f88c962f8cfb50937f316.png";